export default "<img src=\"assets/cards/{{image}}\" class=\"card\" alt=\"{{card.toString()}}\" />"